// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2-E33","errorLogs":"EditorFooter_errorLogs__SLEPJ"};